<template>
  <QPageContainer class="desktop-single-column">
    <QPage :class="{ 'q-px-md': padX, 'q-py-lg': padY }">
      <slot />
    </QPage>
    <QFooter
      :reveal="revealFooter"
      :class="[
        'flex justify-center bg-transparent',
        { 'q-pb-lg': padY, 'no-pointer-events': noFooterPointerEvents }
      ]"
      v-if="$slots.footer"
    >
      <slot name="footer" />
    </QFooter>
  </QPageContainer>
</template>

<script>
import { QPage, QPageContainer, QFooter } from 'quasar';
export default {
  name: 'SAIPageWrapper',
  components: {
    QPageContainer,
    QPage,
    QFooter
  },
  props: {
    padX: {
      type: Boolean,
      default: true
    },
    padY: {
      type: Boolean,
      default: true
    },
    noFooterPointerEvents: Boolean,
    revealFooter: {
      type: Boolean,
      default: true
    }
  }
};
</script>
